import { render } from "./BadgeFifty.vue?vue&type=template&id=35a889fe&scoped=true"
import script from "./BadgeFifty.vue?vue&type=script&lang=js"
export * from "./BadgeFifty.vue?vue&type=script&lang=js"

import "./BadgeFifty.vue?vue&type=style&index=0&id=35a889fe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a889fe"]])

export default __exports__